import { Endpoint } from "@mongez/http";
import { getCurrentLocaleCode } from "@mongez/localization";
import { type GenericObject } from "@mongez/reinforcements";
import { apiBaseUrl, appClientId } from "./environment";

export function endpoint(headers: GenericObject = {}) {
  const endpoint = new Endpoint({
    baseURL: apiBaseUrl,
    headers: {
      "Content-Type": "application/json",
      "locale-code": getCurrentLocaleCode(),
      "client-id": appClientId,
      ...headers,
    },
  });

  endpoint.events.beforeSending((config) => {
    if (config.method?.toLocaleLowerCase() === "post" && !config.data) {
      config.data = {};
    }
  });

  return endpoint;
}
